import React from "react";

import { isAndroid, navigate } from "../../../helpers/utils";

import Header from "../common/header";
import {
  View,
  FlatList,
  TouchableOpacity,
  StyleSheet,
  Text,
  KeyboardAvoidingView,
  Platform,
} from "react-native";
import AppConfig from "../../../config/AppConfig";
import ManaButton from "../common/ManaButton";
import Search from "../common/search-bar/Search";
import appStyles from "../../appStyles";
import AppTheme from "../AppTheme";
import LoadingIndicator from "../common/LoadingIndicator";

export default class ImpersonatePage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      isLoading: false,
      userList: this.controller.state.users,
      userAvatar: this.controller.state?.picture,
    };
  }

  goBack = () => {
    navigate(this.controller, "rn:home_card");
  };

  impersonate = (email) => {
    this.controller.apiService.setImpersonate(email);
    this.controller.resetState(true, email);
    this.controller.getItemsWithStats("feed", "rn:home_card");
  };

  stopImpersonation = () => {
    this.impersonate(null);
  };

  impersonateUser = (email) => {
    this.impersonate(email);
    this.setState((state) => ({ ...state, isLoading: true }));
  };

  filterByKeyword = ({ term }) => {
    let users = [...(this.controller.state.users || [])];
    if (term) {
      users = users.filter((u) =>
        u.email.toLowerCase().includes(term.toLowerCase()),
      );
    }
    this.setState((state) => ({ ...state, userList: users }));
  };

  render() {
    const { isLoading, userList, userAvatar } = this.state;
    const isImpersonation =
      this.controller.state?.impersonate &&
      this.controller.state?.impersonate != this.controller.state?.currentUser;

    const renderItem = ({ item }) => (
      <View style={styles.item}>
        <TouchableOpacity onPress={() => this.impersonateUser(item.email)}>
          <Text style={styles.itemText}>{item.email}</Text>
        </TouchableOpacity>
      </View>
    );

    return (
      <View style={[appStyles.container, { marginBottom: 0 }]}>
        <KeyboardAvoidingView
          style={appStyles.kbViewNoFooter}
          behavior="height"
          keyboardVerticalOffset={isAndroid ? 30 : 0}
        >
          <Header
            title="Select User"
            avatar={userAvatar}
            returnPage="rn:more"
            controller={this.controller}
          />

          <LoadingIndicator isLoading={isLoading} />

          <View style={styles.buttonContainer}>
            {isImpersonation ? (
              <ManaButton
                onPress={this.stopImpersonation}
                style={styles.button}
                styleText={styles.buttonText}
                text={"Stop Impersonation"}
              />
            ) : null}
          </View>

          <FlatList
            style={styles.scrollView}
            contentContainerStyle={{ paddingBottom: 100 }}
            data={userList}
            renderItem={renderItem}
            keyExtractor={(item) => item.email}
          />

          <View style={appStyles.footerOptions}>
            <Search
              showIcon={false}
              controller={this.controller}
              filterResults={this.filterByKeyword}
              placeholder="Search users"
            />
          </View>
        </KeyboardAvoidingView>

        {/*  {this.controller.hasNavigation() ? null : (
          <View style={appStyles.footerOptions}>
            <Footer controller={controller} selectedPage="" />
          </View>
        )} */}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: "#F4F6FA",
    marginRight: 10,
    width: 230,
    height: 40,
    borderRadius: 6,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
  item: {
    paddingLeft: 8,
    paddingTop: 6,
    paddingBottom: 6,
    borderBottomColor: "#F5F5F5",
    borderBottomWidth: 1,
  },
  itemText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 25,
    letterSpacing: 0.175,
    color: "#2D3142",
  },

  buttonContainer: {
    alignItems: "center",
    backgroundColor: "#FFF",
    borderTopLeftRadius: AppConfig.BORDER_RADIUS,
    borderTopRightRadius: AppConfig.BORDER_RADIUS,
    paddingVertical: 20,
  },
  scrollView: {
    paddingHorizontal: 10,
    backgroundColor: "#FFF",
  },
});
